import { defineTokens, defineSemanticTokens } from "@pandacss/dev";

/**
 * Border radius tokens
 * Define consistent rounding values for UI elements
 *
 * @example
 * ```tsx
 * <Box borderRadius="md" />
 * ```
 */
export const radii = defineTokens.radii({
	/** Extra small radius: 0.25rem (4px) */
	xs: { value: "0.25rem" },
	/** Small radius: 0.375rem (6px) */
	sm: { value: "0.375rem" },
	/** Medium radius: 0.5rem (8px) - Default for most components */
	md: { value: "0.5rem" },
	/** Large radius: 0.75rem (12px) */
	lg: { value: "0.75rem" },
	/** Full radius for pill/circle shapes */
	full: { value: "20rem" },
});

/**
 * Semantic border radius tokens
 * Contextual radius values mapped to specific component needs
 */
export const semanticRadii = defineSemanticTokens.radii({
	/** Default button border radius */
	button: { value: "radii.md" },
	/** Pill-shaped elements like badges */
	pill: { value: "radii.full" },
});
